import { CacheRequestConfig } from 'axios-cache-interceptor';
import axiosInstance from './axios';

export type ClipFavourite = { clipId: number; createdAt: string | null; sentToComposer?: boolean | null };

export const getClipFavourites = (feedId: string) => {
  const config: CacheRequestConfig = { cache: false };
  return axiosInstance.get<(ClipFavourite | number)[]>(`clip-favourites/${feedId}?details=true`, config);
};

export const setClipFavourite = (feedId: string, clipId: string, favourite: boolean) =>
  favourite
    ? axiosInstance.put(`clip-favourites/${feedId}/${clipId}`)
    : axiosInstance.delete(`clip-favourites/${feedId}/${clipId}`);

export const setClipFavourites = (feedId: string, clipIds: string[], favourite: boolean, restore?: ClipFavourite[]) =>
  axiosInstance.put<ClipFavourite[]>(`clip-favourites/${feedId}`, { clipIds: clipIds.map(Number), favourite, restore });
